export default function MetaSection({ formData, errors, refs, handleInputChange }) {
  return (
    <div className="mb-6">
      <h2 className="text-xl font-bold mb-4">SEO Meta</h2>

      {/* Meta Title */}
      <label className="block font-medium mb-2">Meta Title</label>
      <input
        ref={refs.MetaTitle}
        name="MetaTitle"
        value={formData.MetaTitle}
        onChange={handleInputChange}
        placeholder="Meta Title"
        className="border p-3 w-full mb-1"
      />
      {errors.MetaTitle && (
        <p className="text-red-600 text-sm mb-3">{errors.MetaTitle}</p>
      )}

      {/* Meta Description */}
      <label className="block font-medium mb-2">Meta Description</label>
      <textarea
        ref={refs.MetaDescription}
        name="MetaDescription"
        value={formData.MetaDescription}
        onChange={handleInputChange}
        placeholder="Meta Description"
        className="border p-3 w-full mb-1"
      />
      {errors.MetaDescription && (
        <p className="text-red-600 text-sm mb-3">
          {errors.MetaDescription}
        </p>
      )}

      {/* Meta Keywords */}
      <label className="block font-medium mb-2">Meta Keywords</label>
      <input
        ref={refs.MetaKeywords}
        name="MetaKeywords"
        value={formData.MetaKeywords}
        onChange={handleInputChange}
        placeholder="Meta Keywords"
        className="border p-3 w-full mb-1"
      />
      {errors.MetaKeywords && (
        <p className="text-red-600 text-sm">{errors.MetaKeywords}</p>
      )}
    </div>
  );
}
